// Render form errors
import React from "react";

const FormErrors = (props) => {
  return (
    <div className="form-error">
      <h3>Uh oh...</h3>
      <p>{props.message}</p>
    </div>
  );
};
export default FormErrors;
